"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shopIntegralApi = require("@/api/shopIntegralApi");
var _IntegralOrderDetail = _interopRequireDefault(require("./IntegralOrderDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 订单状态筛选项：与后端 OrderStatusEnum 一致，请求体 status 为整型
 * （选项 value 用字符串，避免 el-select 在 value=0 时的兼容问题）
 */
var ORDER_STATUS_FILTER_OPTIONS = [{
  label: '全部',
  value: ''
}, {
  label: '已取消',
  value: '0'
}, {
  label: '待支付',
  value: '1'
}, {
  label: '已支付',
  value: '2'
}, {
  label: '处理中',
  value: '3'
}, {
  label: '已发货',
  value: '4'
}, {
  label: '已签收',
  value: '5'
}, {
  label: '已完结',
  value: '6'
}, {
  label: '退款中',
  value: '7'
}, {
  label: '退款成功',
  value: '8'
}, {
  label: '退款失败',
  value: '9'
}, {
  label: '拒绝退款',
  value: '10'
}, {
  label: '已关闭',
  value: '11'
}, {
  label: '支付失败',
  value: '12'
}, {
  label: '向第三方下单失败',
  value: '13'
}, {
  label: '部分退款',
  value: '14'
}, {
  label: '售后中',
  value: '15'
}, {
  label: '部分发货',
  value: '16'
}, {
  label: '待退款',
  value: '71'
}];

/** 订单类型：1 普通商品 2 虚拟卡券 */
var ORDER_TYPE_FILTER_OPTIONS = [{
  label: '全部',
  value: ''
}, {
  label: '普通商品',
  value: '1'
}, {
  label: '虚拟卡券',
  value: '2'
}, {
  label: '优惠券商品',
  value: '3'
}];
function formatMoneyYuan(n) {
  if (n === null || n === undefined || n === '') return '—';
  var num = Number(n);
  if (Number.isNaN(num)) return '—';
  return "\xA5".concat(num.toFixed(2));
}
var _default = exports.default = {
  name: 'IntegralOrder',
  components: {
    IntegralOrderDetail: _IntegralOrderDetail.default
  },
  data: function data() {
    return {
      tableHeaderCellStyle: {
        fontWeight: 'bold',
        textAlign: 'left'
      },
      listLoading: false,
      detailVisible: false,
      /** 与 lists/orderDetail 一致，凭订单号调 /admin/order/detail/{orderNo} */
      detailOrderNo: '',
      constants: this.$constants,
      query: {
        keyword: '',
        status: '',
        orderType: ''
      },
      orderStatusOptions: ORDER_STATUS_FILTER_OPTIONS,
      orderTypeOptions: ORDER_TYPE_FILTER_OPTIONS,
      tableData: [],
      total: 0,
      pageData: {
        page: 1,
        limit: this.$constants.page.limit[0]
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.fetchList();
    });
  },
  methods: {
    formatMoneyYuan: formatMoneyYuan,
    buildListBody: function buildListBody() {
      var body = {};
      var kw = (this.query.keyword || '').trim();
      if (kw) body.keyword = kw;
      if (this.query.orderType !== '' && this.query.orderType != null) {
        var ot = Number(this.query.orderType);
        if (!Number.isNaN(ot)) body.orderType = ot;
      }
      if (this.query.status !== '' && this.query.status != null) {
        var st = Number(this.query.status);
        if (!Number.isNaN(st)) body.status = st;
      }
      return body;
    },
    fetchList: function () {
      var _fetchList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$pageData, page, limit, res, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.listLoading = true;
              _context.p = 1;
              _this$pageData = this.pageData, page = _this$pageData.page, limit = _this$pageData.limit;
              _context.n = 2;
              return (0, _shopIntegralApi.shopIntegralOrderListApi)({
                page: page,
                limit: limit
              }, this.buildListBody());
            case 2:
              res = _context.v;
              data = res || {};
              this.tableData = Array.isArray(data.list) ? data.list : [];
              this.total = data.total != null ? Number(data.total) : 0;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.tableData = [];
              this.total = 0;
            case 4:
              _context.p = 4;
              this.listLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchList() {
        return _fetchList.apply(this, arguments);
      }
      return fetchList;
    }(),
    handleSearch: function handleSearch() {
      this.pageData.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.query = {
        keyword: '',
        status: '',
        orderType: ''
      };
      this.pageData.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.pageData.page = page;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.pageData.limit = limit;
      this.pageData.page = 1;
      this.fetchList();
    },
    goAftersaleList: function goAftersaleList(orderNo) {
      if (!orderNo) return;
      this.$router.push({
        path: '/order/aftersale',
        query: {
          orderNo: String(orderNo)
        }
      });
    },
    handleDetail: function handleDetail(row) {
      this.detailOrderNo = row && row.orderNo != null ? String(row.orderNo) : '';
      this.detailVisible = true;
    }
  }
};